// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2KQA_","header":"ReportDetails_header__3WhcY","title":"ReportDetails_title__1uGzb","left":"ReportDetails_left__1TN0K"};